import React, { Component } from 'react';
import { connect } from 'react-redux';
import NavBar from '../../../../_components/common/Navbar';
import Footer from '../../../../_components/common/Footer';
import SettingsHead from '../../../../_components/common/SettingsHead'
import { tables } from './CustomColumnTable'
import CustomTableNew from '../../../../_components/common/CustomTableNew'
import { CommonBreadCrumb } from '../../../../_components/common/CommonBreadCrumb'
import { manageBatchActions } from '../../../../_actions/organisations/manageBatchList.action'
import ModalNew2 from '../../../../_components/common/ModalNew2'
import Page404 from '../../../404page';
import { addParticipents, allotAssessments } from '../formData';
import { organisationAction } from '../../../../_actions/organisation.action';
import { compareBy } from '../component/CompareFunc';
import { LoaderComp } from '../../../../_components/common/LoaderComp/Loadercomp';
import DeleteModal from '../../../../_components/common/DeleteModal';
import AddParticipantsModal from '../component/AddParticipantsModal';
import swal from 'sweetalert2';



class ManageParticipents extends Component {
    state = {
        locationId: 0,
        orgId: 0,
        sellerId: 0,
        getImpId: false,

        showDetailsModal: false,
        editOrgModal: false,

        modal: false,
        addOrgState: false,
        showHeading: false,
        currentModalId: 11,
        showModalView: true,
        addBatchModal: false,
        selectedBoxData: 1,
        buttonParticipentData: [],
        addParticipentsModal: false,
        deleteParticipentsModal: false,
        allotAssessmentModal: false,
        enablePiModal: false,
        disablePiModal: false,
        participantData: '',
        checkBoxData: [],
        reRenderSettingsHead: 1,
        paticipantListData: [],
        creditDisable: false,
        sortTypeParticipant: false,
        organisationParticipantTable: '',
        breadCrumbData: [],
        allotAssessments: allotAssessments,


        hasProperOrgId: true,
        idLoader: true,

    }

    sortBy(columnKey, type, tableName) {
        if (tableName === 'organisationParticipantTable') {
            this.setState({ sortTypeParticipant: type })
            const arrayCopy = this.state.organisationParticipantTable === '' ? this.props.participentList : this.state.organisationParticipantTable;
            arrayCopy.sort(compareBy(columnKey, this.state.sortTypeParticipant));
            this.setState({ organisationParticipantTable: arrayCopy })

        }
    }

    componentDidUpdate(prevProps, prevState) {



        if (prevProps.participentList !== this.props.participentList) {
            if (this.props.participentList !== '') {
                this.props.participentList.map(val => {
                    if (val.full_name == null) {
                        val.full_name = val.email
                    }
                    val["idString"] = `${val.id}`
                })
            }
        }
        if (prevProps.orgList !== this.props.orgList) {
            if (this.props.orgList !== '') {
                if (!this.state.getImpId) {
                    this.getSellerOrgId()
                }
            }
        }

        if (prevProps.instrumentList !== this.props.instrumentList) {
            let counter = 0;
            if (this.props.instrumentList !== '') {
                this.props.instrumentList.map(val => {
                    val['ChangeKeyInstrument'] = `${val.organisation_assessment_credit__instrument__instrument_name} (${val.unsold_credits} credits remaining)`
                    if (val.credit_in_use === 0) {
                        counter++
                    }
                })
            }
        }


    }

    componentDidMount() {
        const { dispatch, } = this.props;
        const userType = localStorage.getItem('usertype');

        let buttonParticipentData = [
            {
                id: 1,
                heading: "Add Participants",
                state: this.state.addParticipentsModal,
                toggler: this.toggleAddParticipent.bind(this),
                doNotDisable: true
            },
            {
                id: 2,
                heading: "Allot Assesments",
                state: this.state.allotAssessmentModal,
                toggler: this.toggleAllotAssesmet.bind(this),
                disabled: 'disabled'
            }
        ];

        if (!userType.includes('organisation_admin') && !userType.includes('seller_admin')) {

            buttonParticipentData.push({
                id: 3,
                heading: "Delete Participants",
                state: this.state.deleteParticipentsModal,
                toggler: this.toggleDeleteParticipent.bind(this),
                disabled: 'disabled'
            });
        }

        this.setState({
            buttonParticipentData
        });


        dispatch(organisationAction.getOrganisation(() => { }))

        let sellerIdLocal = localStorage.getItem('seller_id')
        let orgIdLocal = localStorage.getItem('orgId')

        let orgIdFromPath = this.props.location.pathname.match(/\d/g);
        orgIdFromPath = orgIdFromPath.join("");

        this.setState({
            locationId: orgIdFromPath
        }, () => {

            if (sellerIdLocal !== 'null' || orgIdLocal !== 'null') {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'MANAGE PARTICIPANTS'
                        }
                    ]
                }, () => {
                    if (orgIdLocal !== 'null') {
                        this.setState({
                            breadCrumbData: [
                                {
                                    link: '/admin/app/dashboard',
                                    name: 'ADMIN'
                                }, {
                                    link: '',
                                    name: 'MANAGE PARTICIPANTS'
                                }
                            ],
                        })
                    }
                })
            } else {
                this.setState({
                    breadCrumbData: [
                        {
                            link: '/admin/app/dashboard',
                            name: 'ADMIN'
                        }, {
                            link: '/admin/app/organisation',
                            name: 'ORGANISATION'
                        }, {
                            link: `/admin/app/organisation/${this.state.locationId}`,
                            name: 'ORGANISATION DETAILS'
                        }, {
                            link: '',
                            name: 'MANAGE PARTICIPANTS'
                        }
                    ]
                })
            }
        })
    }

    filterData = (data) => {
        this.setState({
            participantData: data
        });
    }

    toggleModal(showModal) {
        this.setState({
            modal: showModal
        });
    }

    currentModal(data) {

        this.setState({
            currentModalId: data,
            showModalView: !this.state.showModalView
        })
    }






    toggleAddParticipent = (data) => {
        this.setState({
            addParticipentsModal: data
        });
        if (!data) {
            // Clear the add participants state when closing the modal
            this.props.dispatch(manageBatchActions.clearAddParticipentsState());
        }
    }

    toggleDeleteParticipent(data) {

        this.setState({
            deleteParticipentsModal: data
        })

    }


    toggleEnablePi(data) {
        this.setState({
            enablePiModal: data
        })

    }
    toggleDisablePi(data) {
        this.setState({
            disablePiModal: data
        })

    }
    onAddParticipents(data) {
        const { dispatch } = this.props
        let removeSpaceFromData = data.paricipants.replace(/ /g, '')
        let splitData = removeSpaceFromData.split(',').filter(val => {
            return val !== ''
        })

        dispatch(manageBatchActions.addParticipentsAction({
            sellerId: this.props.getOrgSellerId.sellerId,
            orgId: this.props.getOrgSellerId.orgId,
            data: {
                paricipants: splitData
            }
        }))
    }

    onAddMultipleParticipants = (participants) => {
        const { dispatch } = this.props;

        // Format the participants data
        const formattedParticipants = participants.map(participant => {
            const formattedParticipant = {
                email: participant.email.trim()
            };
            if (participant.name.trim()) {
                formattedParticipant.name = participant.name.trim();
            }
            return formattedParticipant;
        });

        dispatch(manageBatchActions.addParticipentsAction({
            sellerId: this.props.getOrgSellerId.sellerId,
            orgId: this.props.getOrgSellerId.orgId,
            data: {
                participants: formattedParticipants
            }
        }));
    }

    handleAddParticipantsComplete = (response, error) => {
        if (error) {
            swal({
                title: 'Error',
                text: 'An error occurred while adding participants. Please try again.',
                type: 'error',
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            });
        } else if (response && response.data && response.data.message) {
            const messages = response.data.message.map(msg => msg.message).join('\n');
            const type = response.data.message.some(msg => !msg.status) ? 'warning' : 'success';
            swal({
                title: type === 'warning' ? 'Partial Success' : 'Success',
                text: messages,
                type: type,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'OK'
            });
        }
        
        // Refresh the participants list
        // const { orgId, sellerId } = this.state;
        // this.props.dispatch(manageBatchActions.getParticipantsListAction({ orgId, sellerId }));
    }







    addEnablePI(data) {
        const { dispatch } = this.props;
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })

            dispatch(manageBatchActions.enablePiAction({
                sellerId: this.props.getOrgSellerId.sellerId,
                orgId: this.props.getOrgSellerId.orgId,
                data: {
                    users: dataEmail
                }
            }))
        }

    }

    disablePI(data) {
        const { dispatch } = this.props
        if (this.state.checkBoxData.length !== 0) {
            let dataEmail = []
            this.state.checkBoxData.map(val => {
                dataEmail.push(val.id)
            })
            dispatch(manageBatchActions.disablePiAction({
                sellerId: this.props.getOrgSellerId.sellerId,
                orgId: this.props.getOrgSellerId.orgId,
                data: {
                    users: dataEmail
                }
            }))
        }
        // 
    }


    toggleAllotAssesmet(data) {
        const { batchList, instrumentList } = this.props


        let allotAssessments = [...this.state.allotAssessments]

        allotAssessments.map(function (element) {

            if (element.key === 'organisation_batch_list') {
                element.elementConfig.options = batchList;
            }

            if (element.key === 'organisation_credit_list') {
                element.elementConfig.options = instrumentList;
            }
            if (element.key !== 'organisation_batch_list') {
                element.valid = false
            }
            if (element.key === 'expiry_list') {
                element.valid = true
            }
        });

        this.setState({
            allotAssessments
        }, () => {
            this.setState({
                allotAssessmentModal: data
            })
        })

    }

    selectAllParticipantsBox(data, clickToggle) {

        const { buttonParticipentData } = this.state;
        clickToggle === true ?
            buttonParticipentData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = ''
                    this.setState({
                        reRenderSettingsHead: 2,
                        paticipantListData: data
                    })
                }
            })
            :
            buttonParticipentData.map(val => {
                if (val.disabled !== undefined) {
                    val.disabled = 'disabled'
                    this.setState({
                        reRenderSettingsHead: 1,
                        paticipantListData: data
                    })
                }
            })
    }


    addAssessments(data) {

        const { dispatch } = this.props;
        let participantIdArr = [];
        let intrumentIdVar = 0;
        this.state.paticipantListData.map(val => {
            participantIdArr.push(val.id)
        })

        var newdate = data.expiry_list.split("/").reverse().join("-");




        dispatch(manageBatchActions.allotAssessParticipantAction({
            apiData: {
                users: participantIdArr,
                instrument_id: data.organisation_credit_list,
                organisation_id: this.props.getOrgSellerId.orgId,
                organisation_batch_id: parseInt(data.organisation_batch_list, 10),
                expiry_date: newdate
            },
            getParticipants: {
                orgId: this.state.orgId,
                sellerId: this.state.sellerId
            }
        }))
    }

    getSelectedData(data) {
        if (data.length !== 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllParticipantsBox(this.state.checkBoxData, true)
            })
        } else if (data.length === 0) {
            this.setState({ checkBoxData: data }, () => {
                this.selectAllParticipantsBox(this.state.checkBoxData, false)
            })
        }
    }


    getSellerOrgId() {
        const { dispatch } = this.props;
        const { locationId } = this.state;
        const { orgList } = this.props;


        let organisationId = parseInt(locationId, 10)

        orgList !== '' &&
            this.mapOrgList({
                orgList,
                locationId: organisationId,
                dispatch
            })

    }

    mapOrgList(objectData) {
        const { orgList, locationId, dispatch } = objectData

        let hasId = false;

        orgList.map(val => {
            if (locationId == val.id) {
                hasId = true;
                return this.setStateForIds({
                    val,
                    dispatch,
                    locationId
                })
            }
        })

        this.setState({
            hasProperOrgId: hasId,
            idLoader: false,
        })
    }

    setStateForIds(objectData) {
        const { locationId, val, dispatch } = objectData;

        return this.setState({
            orgId: locationId,
            sellerId: val.seller__id,
            getImpId: true,
        }, () => {
            const { orgId, sellerId } = this.state;

            dispatch(manageBatchActions.allotAssessmentInstrumentListAction({
                sellerId,
                orgId
            }))


            dispatch(manageBatchActions.getBatchList({
                orgId,
                sellerId
            }));



            dispatch(manageBatchActions.getParticipantsListAction({
                orgId,
                sellerId
            }))

            dispatch(organisationAction.setIds({
                orgId,
                sellerId
            }))

        })
    }
    handleChildData = (data) => {
        this.setState({ showDetailsModal: data })
    }


    renderManageParticipents() {
        const { participentList, participant_list_loading, participant_list_error } = this.props;

        const filteredDataParticipent = this.state.participantData === '' ? participentList : this.state.participantData;

        const { add_par_loading, add_par, add_par_error } = this.props.addParticipentsState;



        return (
            <div className="container custom-container my-5" >

                <div style={{ marginBottom: 30 }}>
                    <CommonBreadCrumb
                        data={this.state.breadCrumbData}
                    />
                    <div className="bg-green rounded-top">
                        {
                            (!participant_list_loading && !participant_list_error) ?
                                <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> ACTIVE PARTICIPANTS </p>
                                :
                                <div className="text-right d-flex" style={{ justifyContent: 'space-between' }}>
                                    <p></p>
                                    <p className="h6 text-center text-uppercase py-2 text-white mb-0 quattrocentosans regular"> ACTIVE PARTICIPANTS </p>
                                    <LoaderComp color={'white'} />
                                </div>
                        }
                    </div>


                    {
                        (!participant_list_loading && !participant_list_error) &&
                            this.state.reRenderSettingsHead === 1 || this.state.reRenderSettingsHead === 2 ?
                            <div className="animation-fade-in">
                                <SettingsHead
                                    buttonData={
                                        this.state.buttonParticipentData
                                    }

                                    secondColumn={false}

                                    columns={tables.Participants}

                                    sellers={participentList}

                                    view={this.filterData.bind(this)}

                                    modal={this.toggleModal.bind(this)}
                                    showModal={false}
                                    filter="true"
                                    widthClass={'col-md-6'}
                                />
                            </div>
                            :
                            null
                    }
                    <CustomTableNew
                        tableType={'ACTIVE PARTICIPANTS'}
                        data={filteredDataParticipent}
                        columns={tables.Participants}
                        showSlNo="false"
                        checkbox="true"
                        selectCheckBox={this.selectAllParticipantsBox.bind(this)}
                        getData={this.getSelectedData.bind(this)}
                        format={[{
                            format: 'icon',
                            key: 'user_access__is_pi_enabled'
                        }]}
                        CheckKey={"idString"}
                        sortBy={(key) => this.sortBy(key, !this.state.sortTypeParticipant, 'organisationParticipantTable')}
                        sortType={this.state.sortTypeParticipant}
                    />
                    {
                        this.state.addParticipentsModal &&
                        <AddParticipantsModal
                        isOpen={this.state.addParticipentsModal}
                        toggle={() => this.toggleAddParticipent(!this.state.addParticipentsModal)}
                        onSubmit={this.onAddMultipleParticipants}
                        response={this.props.addParticipentsState.add_par}
                        isLoading={this.props.addParticipentsState.add_par_loading}
                        error={this.props.addParticipentsState.add_par_error}
                        onSubmitComplete={this.handleAddParticipantsComplete}
                    />
                    }


                    {
                        this.state.deleteParticipentsModal &&
                        <DeleteModal
                            heading="DELETE PARTICIPANTS"
                            showModal={this.state.deleteParticipentsModal}
                            formData={this.state.checkBoxData}
                            selects={[]}
                            action={this.onAddParticipents.bind(this)}
                            toggleModal={this.toggleDeleteParticipent.bind(this)}
                            viewMessage={[{ text: 'Participant Email IDs' }]}
                            triggerType={"CREATE PARTICIPANTS"}
                            className="deleteModalWrapper"
                            orgId={this.state.orgId}
                            sellerId={this.state.sellerId}

                        />
                    }


                    {
                        this.state.allotAssessmentModal &&
                        <ModalNew2
                            heading="ALLOT ASSESSMENTS"
                            showModal={this.state.allotAssessmentModal}
                            formData={this.state.allotAssessments}

                            selects={['batch_name', 'ChangeKeyInstrument']}
                            action={this.addAssessments.bind(this)}
                            toggleModal={this.toggleAllotAssesmet.bind(this)}
                            viewMessage={!this.state.creditDisable ? [{ text: `You have selected ${this.state.checkBoxData.length} participant.` }] : [{ text: `You have selected ${this.state.checkBoxData.length} participant.` }]}
                            triggerType={"FINISH"}
                            selectKey={['id', 'instrument__id']}
                            disableButton={false}
                        />
                    }

                </div>
            </div>
        )
    }

    render() {
        if (true) {
            return (
                <div>
                    <NavBar />
                    {
                        this.state.idLoader ?
                            <div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
                                <LoaderComp color={'black'} />
                            </div>
                            :
                            this.state.hasProperOrgId ?
                                this.renderManageParticipents()
                                :
                                <Page404 />
                    }
                    <Footer />
                </div>
            );
        } else {
            return (
                // add swal
                <h1>Something went wrong</h1>
            );
        }

    }

}

function mapStateToProps(state) {

    //get add participants
    const { add_par_loading, add_par, add_par_error } = state.addParticipents;





    const orgError = state.organisation.error;
    const orgLoading = state.organisation.loading;
    const orgList = (!orgError && !orgLoading) ? state.organisation.organisation.data.organisation_list : ''

    //Manage participants

    const { participant_list_loading, participant_list_error } = state.participantsList;
    const participentList = (!participant_list_loading && !participant_list_error) ? state.participantsList.participant_list.data.participant_list : ''

    //GET Batch List

    const { batch_list_error, batch_list_loading } = state.managaBatchList;
    const batchList = (!batch_list_error && !batch_list_loading) ? state.managaBatchList.batch_list.data.organisation_batch_list : '';

    //get org and seller id

    const getOrgSellerId = state.setSellerAndOrgId

    //GET instrument list

    const { instrument_list_error, instrument_list_loading } = state.instrumentList;
    const instrumentList = (!instrument_list_error && !instrument_list_loading) ? state.instrumentList.instrument_list.data.organisation_credit_list : '';

    return {
        participant_list_loading,
        participant_list_error,
        participentList,
        batch_list_error,
        batch_list_loading,
        batchList,
        getOrgSellerId,
        instrumentList,
        orgError,
        orgLoading,
        orgList,
        addParticipentsState: { add_par_loading, add_par, add_par_error },

    };
}

export default connect(mapStateToProps)(ManageParticipents);


// WEBPACK FOOTER //
// ./src/_pages/Admin/Organisation/DetailLinks/ManageParticipents.js